"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeighborFinder = void 0;
const utils_1 = require("@streamr/utils");
const INITIAL_WAIT = 100;
const INTERVAL = 250;
const logger = new utils_1.Logger(module);
class NeighborFinder {
    abortController;
    options;
    running = false;
    constructor(options) {
        this.options = options;
        this.abortController = new AbortController();
    }
    async findNeighbors(excluded) {
        if (!this.running) {
            return;
        }
        const newExcludes = await this.options.doFindNeighbors(excluded);
        const uniqueContactCount = new Set([
            ...this.options.nearbyNodeView.getIds(),
            ...this.options.leftNodeView.getIds(),
            ...this.options.rightNodeView.getIds(),
            ...this.options.randomNodeView.getIds()
        ]).size;
        if (this.options.neighbors.size() < this.options.minCount && newExcludes.length < uniqueContactCount) {
            // TODO should we catch possible promise rejection?
            (0, utils_1.setAbortableTimeout)(() => this.findNeighbors(newExcludes), INTERVAL, this.abortController.signal);
        }
        else if (this.options.neighbors.size() === 0 && uniqueContactCount > 0) {
            logger.debug('No neighbors found yet contacts are available, restarting handshaking process');
            (0, utils_1.setAbortableTimeout)(() => this.findNeighbors([]), INTERVAL, this.abortController.signal);
        }
        else {
            this.running = false;
        }
    }
    isRunning() {
        return this.running;
    }
    start(excluded = []) {
        if (this.running) {
            return;
        }
        this.running = true;
        // TODO should we catch possible promise rejection?
        (0, utils_1.setAbortableTimeout)(async () => {
            await Promise.all([
                this.findNeighbors(excluded),
                this.findNeighbors(excluded)
            ]);
        }, INITIAL_WAIT, this.abortController.signal);
    }
    stop() {
        if (!this.running) {
            return;
        }
        this.running = false;
        this.abortController.abort();
    }
}
exports.NeighborFinder = NeighborFinder;
//# sourceMappingURL=NeighborFinder.js.map